var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { Button, Trans } from '@lucidlink/uicore';
export const WorkspaceSuspendedNavToBilling = ({ workspaceId, }) => {
    _react_refresh_temp_2();
    const navigate = useNavigate();
    return (_jsx(Button, { "data-testid": "suspended-workspace", onClick: () => navigate(`/workspaces/${workspaceId}/settings/billing`), size: "big", children: _jsx(Trans, { children: "Go to Billing and invoices" }) }));
};
_react_refresh_temp_1 = WorkspaceSuspendedNavToBilling;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceSuspendedNavToBilling");
_react_refresh_temp_2(WorkspaceSuspendedNavToBilling, "CzcTeTziyjMsSrAVmHuCCb6+Bfg=", false, () => [useNavigate]);
